import React from 'react';
import Avatar from '../components/Avatar';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import Link from '../utils/router/Link';
import userPath from '../utils/url/userPath';
import UserBadge from './profile/UserBadge';
import UserDetailPreviewPopOver from './UserDetailPreviewPopOver';
import * as styles from './UserRow.module.scss';

const USER_ROW_USER_FRAGMENT = gql(`
  fragment UserRow_user on User {
    id
    name
    title
    ...Avatar_user
    ...UserBadge_user
  }
`);

interface UserRowProps {
  link?: boolean;
  showBadge?: boolean;
  showHoverCard?: boolean;
  user: DocumentType<typeof USER_ROW_USER_FRAGMENT>;
  avatarSize?: React.ComponentProps<typeof Avatar>['size'];
}

const UserRow = ({
  link = false,
  showBadge = false,
  showHoverCard = false,
  user,
  avatarSize,
}: UserRowProps) => {
  let view = (
    <div className={styles.innerContainer}>
      <div className={styles.avatarContainer}>
        <Avatar user={user} size={avatarSize} />
      </div>
      <div className={styles.infoContainer}>
        <div className={styles.nameContainer}>
          <div className={styles.name}>{user.name}</div>
          {showBadge && (
            <div className={styles.badgeContainer}>
              <UserBadge user={user} />
            </div>
          )}
        </div>
        {user.title && <div className={styles.title}>{user.title}</div>}
      </div>
    </div>
  );

  if (link) {
    view = (
      <Link
        className={styles.link}
        to={userPath(user)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={user.name}
      >
        {view}
      </Link>
    );
  }

  if (!showHoverCard) {
    return view;
  }
  return (
    <UserDetailPreviewPopOver
      allowCrossAxisFlip
      userId={user.id}
      placement="top-start"
    >
      {view}
    </UserDetailPreviewPopOver>
  );
};

export default UserRow;
